import AntCol from 'antd/lib/col';

export const Col = AntCol;
